import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { IndexComponent } from './index.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { SliderModule } from 'src/app/shared/components/slider/slider.module';
import { ReactiveFormsModule } from '@angular/forms';


const routes: Routes = [
  {
    path: '',
    component: IndexComponent,
  }
];

@NgModule({
  declarations: [IndexComponent],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    SliderModule,
    SharedModule,
    ReactiveFormsModule
  ]
})
export class SaasMainModule { }
